import { Popover as ShadCNPopover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import QuestionIcon from "@sprout/icons/question.tsx";
import "@/stylesheets/help_popover.scss";
import { cn } from "@/lib/utils.ts";

type PopoverProps = {
  text: string;
  className?: string;
};

const HelpPopover = ({ text, className }: PopoverProps) => {
  return (
    <div className={cn("help-popover", className)}>
      <ShadCNPopover>
        <PopoverTrigger>
          <QuestionIcon size="sm" />
        </PopoverTrigger>
        <PopoverContent
          collisionPadding={16}
          side="bottom"
          align="start"
          className="bg-gray-500 max-w-50"
        >
          <p>{text}</p>
        </PopoverContent>
      </ShadCNPopover>
    </div>
  );
};

export default HelpPopover;
